/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : RolesAndAccessMain.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author : Narender - narender@au79consulting.com
 * @Date : 27-06-2024
 * @description Component for managing roles and access permissions view.
 */
import React, { useState } from "react";
import RolesAndAccess from "./RolesAndAccess";

/**
 * @author : Narender - narender@au79consulting.com
 * @Date : 27-06-2024
 * @description Main component for managing roles and access permissions.
 * @param : none
 * @return The rendered main roles and access management component.
 */
function RolesAndAccessMain() {
  const [isAddRole, setIsAddRole] = useState(false);



  return (
    

      <RolesAndAccess setIsAddRole={setIsAddRole} isAddRole={isAddRole} />
    
  );
}

export default RolesAndAccessMain;
